var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vw-grid feature-list"},_vm._l((_vm.content),function(feature,index){return (_vm.showBlock(index, feature.locales))?_c('Feature',{key:index,staticClass:"half-grid",attrs:{"slide":feature,"active":"0"}}):_vm._e()}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e140703a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/vuejs/frontend/2023-launch/components/FeaturesList.vue
// module id = gwBD
// module chunks = 4